<template>
  <div class="AddIrDevice lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddIrDevice-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddIrDevice-main lxn-pos-rel">
      <div class="AddIrDevice-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddIrDevice_title1}}
          </template>
          <template v-slot:body>
            <div class="AddIrDevice-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddIrDevice_text1}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="DeviceName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddIrDevice_namePlaceHolder" inputType="text" />
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddIrDevice_title2}}
          </template>
          <template v-slot:body>
            <div class="AddIrDevice-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddIrDevice_text2}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetDeviceType" :dropDownContex="dropDownTargetDeviceTypes" />
            </div>
            <div class="AddIrDevice-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddIrDevice_text3}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetBrand" :dropDownContex="dropDownTargetBrands" />
            </div>
            <div class="AddIrDevice-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddIrDevice_text4}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetModel" :dropDownContex="dropDownTargetModels" />
            </div>
            <div class="AddIrDevice-wrapper-fieldText lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddIrDevice_text5}}
            </div>
            <div class="AddIrDevice-wrapper-button lxn-margin-auto lxn-w100">
              <CustomButton @click="testDevice" bgColor="#1EA5DE" iconRight="test" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isNodeOffline">
                {{$store.getters.language.texts.AddIrDevice_testDevice}}
              </CustomButton>
            </div>
            <div class="IrDeviceSettings-wrapper-button lxn-margin-auto lxn-w100">
              <CustomButton @click="turnDeviceOff" bgColor="#1EA5DE" iconRight="turnOff" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isNodeOffline">
                {{$store.getters.language.texts.AddIrDevice_turnDeviceOff}}
              </CustomButton>
            </div>
          </template>
        </TitleBox>
      </div>
      <div class="AddIrDevice-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddIrDevice_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'
import DropDown from '@/components/DropDown.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'

export default {
  name: 'AddIrDevice',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    DropDown,
  },
  data: function () {
    return {
      DeviceName: '',
      input1State: '',
      targetDeviceType: 0,
      targetBrand: 0,
      targetModel: 0,
    }
  },
  mounted: function () {
  },
  watch: {
    targetDeviceType: function (){
      this.targetBrand = 0;
      this.targetModel = 0;
    },
    targetBrand: function (){
      this.targetModel = 0;
    },
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.node.color];
    },
    node: function () {
      return this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID);
    },
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    dropDownTargetDeviceTypes: function () {
      var dropDownTargetDeviceTypes = {
        name: "AddIrDevice-TargetDeviceTypes",
        title: this.$store.getters.language.texts.AddIrDevice_text2,
        selectedIndex: this.targetDeviceType,
        data: []
      };
      for(var i = 0; i < NODE7.devices.length; i++){
        dropDownTargetDeviceTypes.data.push({
          name: this.$store.getters.language.texts[NODE7.devices[i].name],
          icon: NODE7.devices[i].icon,
        })
      }
      return dropDownTargetDeviceTypes;
    },
    dropDownTargetBrands: function () {
      var dropDownTargetBrands = {
        name: "AddIrDevice-TargetBrands",
        title: this.$store.getters.language.texts.AddIrDevice_text3,
        selectedIndex: this.targetBrand,
        data: []
      };
      for(var i = 0; i < NODE7.devices[this.targetDeviceType].brands.length; i++){
        dropDownTargetBrands.data.push({
          name: NODE7.devices[this.targetDeviceType].brands[i].name,
          icon: NODE7.devices[this.targetDeviceType].icon,
        })
      }
      return dropDownTargetBrands;
    },
    dropDownTargetModels: function () {
      var dropDownTargetModels = {
        name: "AddIrDevice-TargetModels",
        title: this.$store.getters.language.texts.AddIrDevice_text4,
        selectedIndex: this.targetModel,
        data: []
      };
      for(var i = 0; i < NODE7.devices[this.targetDeviceType].brands[this.targetBrand].devices.length; i++){
        dropDownTargetModels.data.push({
          name: NODE7.devices[this.targetDeviceType].brands[this.targetBrand].devices[i].name,
          icon: NODE7.devices[this.targetDeviceType].icon,
        })
      }
      return dropDownTargetModels;
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    testDevice: function () {
      this.$store.commit('setAppBusy', true);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: this.hub.psk,
        destinationUUID: this.hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      var IrDevice = NODE7.devices[this.targetDeviceType].brands[this.targetBrand].devices[this.targetModel];
      this.$store.dispatch('setNodesParameters', {
        messagingHook: messagingHook,
        hubUUID: this.hub.uuid,
        nodeUUID: this.node.uuid,
        bodyContent: {
          nodeActions: [
            {
              nodeUUID: this.node.uuid,
              actions: [
                {
                  parameterId: NODE7.IR.PARAMETER_ID,
                  valueOfChange: messagingHook.utility.arrayTo128(IrDevice.commands[IrDevice.defaultCommandIndex].command),
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  timeDelay: 0
                }
              ]
            },
          ]
        }
      })
      .then( () => {
        this.$store.commit('setAppBusy', false);
      })
      .catch( response => {
        if(response.rejectCode == 1){
          this.$router.push('/SettingsNodeError');
        }else if(response.rejectCode == 2){
          this.$router.push('/SettingsHubError');
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        this.$store.commit('setAppBusy', false);

      });
    },
    turnDeviceOff: function () {
      this.$store.commit('setAppBusy', true);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: this.hub.psk,
        destinationUUID: this.hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      var IrDevice = NODE7.devices[this.targetDeviceType].brands[this.targetBrand].devices[this.targetModel];
      this.$store.dispatch('setNodesParameters', {
        messagingHook: messagingHook,
        hubUUID: this.hub.uuid,
        nodeUUID: this.node.uuid,
        bodyContent: {
          nodeActions: [
            {
              nodeUUID: this.node.uuid,
              actions: [
                {
                  parameterId: NODE7.IR.PARAMETER_ID,
                  valueOfChange: messagingHook.utility.arrayTo128(IrDevice.commands[0].command),
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  timeDelay: 0
                }
              ]
            },
          ]
        }
      })
      .then( () => {
        this.$store.commit('setAppBusy', false);
      })
      .catch( response => {
        if(response.rejectCode == 1){
          this.$router.push('/SettingsNodeError');
        }else if(response.rejectCode == 2){
          this.$router.push('/SettingsHubError');
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        this.$store.commit('setAppBusy', false);

      });
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.DeviceName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddIrDevice_alert1);
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.commit('addOutputToDevice', {
          nodeIndex: this.node.index,
          output: {
            icon: NODE7.devices[this.targetDeviceType].icon,
            name: this.DeviceName,
            parameterId: NODE7.IR.PARAMETER_ID,
            type: 'IrDevice',
            settings: {
              deviceType: this.targetDeviceType,
              brand: this.targetBrand,
              model: this.targetModel,
            }
          }
        });
        this.$store.commit('saveState');
        this.$router.push('/home/devices/');
        this.$store.commit('setAppBusy', false);
      }
    },
  }
}
</script>

<style>
  .AddIrDevice-topCurve-wrapper {
    height: 200px;
  }
  .AddIrDevice-main {
    z-index: 2;
  }
  .AddIrDevice-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .AddIrDevice-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .AddIrDevice-wrapper-colors {
    height: 50px;
  }
  .AddIrDevice-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .AddIrDevice-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .AddIrDevice-color.active .AddIrDevice-selectedColor {
    opacity: 1;
  }
  .AddIrDevice-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .AddIrDevice-wrapper-name-text {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .AddIrDevice-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .AddIrDevice-wrapper-fieldText {
    margin-top: 14px;
    line-height: 20px;
    color: #52626C;
  }
  .AddIrDevice-wrapper-button {
    width: calc(100% - 36px);
    margin-top: 15px;
    margin-bottom: 14px;
  }
  .AddIrDevice-wrapper-commands {
    height: 70px;
    background-color: #FFFFFF;
    padding: 5px;
    margin-top: 14px;
  }
  .AddIrDevice-wrapper-commands:first-child {
    margin-top: 0;
  }
  .AddIrDevice-wrapper-command {
    height: 20px;
    line-height: 20px;
  }
  .AddIrDevice-wrapper-commands-trash {
    left: 5px;
    top: 5px;
    width: 30px;
    height: 30px;
  }
</style>
